export default {
  moduleName: "product",
  namespaced: true,
  state: {
    currentProduct: undefined,
  },
  getters: {
    currentProduct: (state) => state.currentProduct,
  },
  mutations: {
    currentProduct: (state, value) => (state.currentProduct = value),
  },
  actions: {
    async setCurrentProduct({ commit }, payload) {
      return commit("currentProduct", payload);
    },
  },
};
